import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import { registerServiceWorker } from "./register-sw";
import * as serviceWorker from "./serviceWorker";
import "./assets/css/bootstrap-rtl.min.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/swiper.min.css";
import "./assets/css/App.css";
import "./assets/css/rangeslider.min.css";
import "./assets/css/VPyEor.css";
import { MemoryRouter } from "react-router";
import { I18nextProvider } from "react-i18next";
import i18n from "./config/i18n";
import ls from "local-storage";
import { PostHogProvider } from "posthog-js/react";
import { POSTHOG_KEY, POSTHOG_URL } from "./Config";
// import { PosthogClient } from "./Posthogprovider/PosthogClient";
import posthog from "posthog-js";

const options = {
  api_host: POSTHOG_URL,
};

//  var hosturl = window.location.protocol +"//" + window.location.hostname;
// localStorage.setItem('api_url',hosturl+"/moulookweb/api/");
//  localStorage.setItem('web_url',hosturl+"/moulookweb/web/");

//  var hosturl = 'http://localhost';

localStorage.setItem('api_url',"https://www.moulook.com/moulookweb/api/");
localStorage.setItem('web_url',"https://www.moulook.com/moulookweb/web/");
// localStorage.setItem("api_url", "https://appservices.hitasoft.in/moulook/api/");
// localStorage.setItem("web_url", "https://appservices.hitasoft.in/moulook/web/");
// localStorage.setItem("api_url", "http://localhost/moulook/api/");
// localStorage.setItem("web_url", "http://localhost/moulook/web/");
//  var hosturl = window.location.protocol +"//" + window.location.hostname;
// localStorage.setItem('api_url',hosturl+"/moulookweb/api/");
// localStorage.setItem('web_url',hosturl+"/moulookweb/web/");

//  var hosturl = 'http://localhost';
//localStorage.setItem('api_url',"https://appservices.hitasoft.in/moulookweb/api/");

registerServiceWorker();

var weburl = localStorage.getItem("web_url");
const style = document.getElementById("style-direction");
const langKey = ls.get("LangValue");
if (langKey === "ar") {
  style.href = weburl + "styles/rtl.css";
} else {
  style.href = weburl + "styles/ltr.css";
}

(function (open, send) {
  XMLHttpRequest.prototype.open = function () {
    open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    console.log("set withCredentials");
    this.withCredentials = false;
    send.apply(this, arguments);
  };
})(XMLHttpRequest.prototype.open, XMLHttpRequest.prototype.send);

posthog.init(POSTHOG_KEY, {
  api_host: POSTHOG_URL,
  autocapture: false,
  xhr_headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

// posthog.init(POSTHOG_KEY, {
//   api_host: POSTHOG_URL,
//   autocapture:false
// });

// posthog.init('<ph_project_api_key>', {
//   api_host: 'https://posthog.moulook.com',
//   autocapture: false,
//   xhr_headers: {
//       'Access-Control-Allow-Origin': '*'
//   }
// })

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <PostHogProvider client={posthog}>
      <MemoryRouter>
        <App />
      </MemoryRouter>
    </PostHogProvider>
  </I18nextProvider>,
  document.getElementById("root")
);
serviceWorker.register();
